var React = require('react');

function Lab2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M42.249 37.842L30.276 19.549v-4.885h.329c1.652 0 3-1.346 3-3s-1.348-3-3-3h-1.319l1.133-5.001a2.984 2.984 0 00-.582-2.535A2.982 2.982 0 0027.493 0h-9.108c-.917 0-1.771.411-2.344 1.128a2.992 2.992 0 00-.583 2.535l1.133 5.001h-1.318c-1.654 0-3 1.346-3 3s1.346 3 3 3h.328v4.885L3.422 38.158a4.995 4.995 0 00-.215 5.116 4.997 4.997 0 004.398 2.622h30.687c2.758 0 5-2.243 5-5a4.898 4.898 0 00-1.043-3.054zM29.032 26.365a2 2 0 11-.001 4.001 2 2 0 01.001-4.001zm-3.417 10.583a2.833 2.833 0 110-5.666 2.833 2.833 0 010 5.666zm6.999 5.834a4.166 4.166 0 01-4.166-4.167 4.166 4.166 0 118.333 0 4.166 4.166 0 01-4.167 4.167z","fill":"currentColor"}));
}

Lab2.defaultProps = {"viewBox":"0 0 45.896 45.896"};

module.exports = Lab2;

Lab2.default = Lab2;
